<template>
  <div class="pageview" style="padding: 10px;">
    <!-- 搜索区域 -->
    <van-field
      v-model="queryParams.content"
      placeholder="请输入内容"
      clearable
      style="margin-bottom: 10px;border: 1px solid #eee;"
    />

    <div style="display: flex; gap: 10px; margin-bottom: 15px;">
      <van-button type="info" size="small" icon="search" @click="handleQuery">搜索</van-button>
      <van-button size="small" icon="replay" @click="resetQuery">重置</van-button>
      <van-button type="primary" size="small" icon="plus" @click="$refs.addAudio.openDialog()">新增</van-button>
    </div>

    <!-- 数据列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
       v-model="loading"
  :finished="finished"
  finished-text="没有更多了"
  @load="getList"
  offset="100"
      >
        <div v-for="(item, index) in dataList" :key="index" class="record-card" @click="showPopup(item.content)">
          <van-cell-group inset>
            <van-cell :border="borderFalse" title="用户名" :value="item.userName" />
            <van-cell :border="borderFalse" title="内容">
              <template slot="">
                <span class="van-multi-ellipsis--l2">{{ item.content }}</span>
              </template>
            </van-cell>
            <van-cell :border="borderFalse" title="语音文件">
              <template slot="">
                <audio
                  controls
                   style="width: 100%; height: 60px;"
                  :src="item.voiceLink"
                />
              </template>
            </van-cell>
            <van-cell title="创建时间" :value="item.createTime" />
          </van-cell-group>

          <div style="margin-top: 10px; display: flex; justify-content: flex-end; gap: 10px;padding: 20px 10px;">
            <van-button
              size="small"
              type="primary"
              icon="down"
              @click.stop="downloadFileWithAuth(item.voiceLink)"
            />
            <van-button
              size="small"
              type="danger"
              icon="delete"
              @click="handleDelete(item)"
            />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 分页 -->
    <div style="padding: 15px 0; text-align: center;" v-if="total > 0">
      共 {{ total }} 条
    </div>
<van-popup v-model="contentShow" style="width: calc(90% - 40px);padding: 20px;border-radius: 5px; max-height: 300px;">
  <div class="contentBox">
   <span style="font-size: 16px;"> 内容：</span>
   <span style="font-size:14px; color: #666666; display: block; margin-top: 5px;">{{ curContent }}</span>
  </div>
</van-popup>
    <!-- 新增语音弹窗 -->
    <add-audio ref="addAudio" @ok="onAddOk" />
  </div>
</template>

<script>
import { getvoiceList, delVoiceSynthesis } from "@/api/index";
import addAudio from "@/views/system/home/addAudioVant"; // 移动端专用组件
import axios from "axios";
export default {
  components: {
    addAudio
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        content: '',
        userId: '',
        platForm: '',
        type: 1
      },
      loading: false,
      refreshing: false,
      finished: false,
      total: 0,
      dataList: [],
      userId: "",
      userName: "",
      platForm: "",
      borderFalse: false,
      contentShow: false,
      curContent:''
    };
  },
  mounted() {
    this.userId = this.$route.query.userId == 1 ? '99999' : this.$route.query.userId;
    this.userName = this.$route.query.userName;
    this.platForm = this.$route.query.platForm;

    this.queryParams.userId = this.userId;
    this.queryParams.userName = this.userName;
    this.queryParams.platForm = this.platForm;

    // this.getList();
  },
  methods: {
    onAddOk() {
      this.resetQuery();
    },
      showPopup(content) {
      this.contentShow = true;
      this.curContent = content;
    },
    getList() {
     // 下拉刷新时，重置分页
  if (this.refreshing) {
    this.queryParams.pageNum = 1;
  }

  // 只有在非刷新且未完成时才加载下一页
  getvoiceList(this.queryParams).then(response => {
    const result = response.data.data || {};
    const list = result.list || [];
    const total = result.total || 0;

    // 刷新时清空，追加时 push
    if (this.refreshing) {
      this.dataList = list;
      this.refreshing = false;
    } else {
      this.dataList.push(...list);
    }

    this.total = total;
    this.queryParams.pageNum++; // ✅ 只在成功后递增页码
    this.loading = false;

    // 判断是否加载完毕
    if (this.dataList.length >= total) {
      this.finished = true;
    }
  }).catch(() => {
    this.loading = false;
    this.finished = true;
  });
    },
    onRefresh() {
      this.resetPagination();
  this.refreshing = true;
  this.getList(); // ✅ 触发 getList，内部会处理 pageNum = 1
    },
    handleQuery() {
      this.resetPagination();
  this.refreshing = true; // 触发刷新样式
  // this.getList();
    },
    resetQuery() {
      this.queryParams = {
    pageNum: 1,
    pageSize: 10,
    content: '',
    userId: this.userId,
    platForm: this.platForm,
    type: 1
  };
  this.resetPagination();
  this.refreshing = true;
  // this.getList();
    },
    resetPagination() {
      this.dataList = [];
  this.total = 0;
  this.loading = false;
  this.finished = false;
    },
    handleDelete(row) {
      this.$dialog.confirm({
        title: '确认删除',
        message: `是否确认删除编号为 "${row.id}" 的数据？`
      }).then(() => {
        delVoiceSynthesis({ id: row.id }).then(() => {
          this.$toast.success('删除成功');
          this.resetQuery();
        });
      }).catch(() => {
        // 取消
      });
    },
  async downloadFileWithAuth(voiceLink) {
      const fileUrl = voiceLink; // 需要认证的 URL
      const fileName = "audio.mp3"; // 你期望的文件名

      try {
        // 使用 axios 请求文件，responseType 设置为 'blob'
        const response = await axios.get(fileUrl, {
          responseType: "blob", // 关键：告诉 axios 将响应作为二进制大对象处理
          headers: {
            // 如果需要认证，添加请求头
            // 'Authorization': 'Bearer your-jwt-token-here'
            // 其他可能的头...
          },
        });
        console.log(response);
        // 检查响应状态
        if (response.status === 200) {
          // 创建一个 Blob URL
          const blob = new Blob([response.data], { type: response.data.type });
          console.log(blob);
          const url = window.URL.createObjectURL(blob);
          console.log(url);
          // 创建一个临时的 <a> 标签来触发下载
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();

          // 清理：移除元素并释放 Blob URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$modal.msgSuccess("下载成功");
        } else {
          console.error("下载失败:", response.statusText);
        }
      } catch (error) {
        console.error("下载过程中出错:", error);
        // 处理错误，例如显示错误消息
      }
    },
  }
};
</script>

<style scoped>
.record-card {
  margin-bottom: 15px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.contentBox{
  padding: 10px;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  text-align: justify;
  width: 90%;
}
</style>